// Translation utilities

export const translations = {
  en: {
    // Navigation
    home: "Home",
    about: "About",
    howItWorks: "How It Works",
    pricing: "Pricing",
    testimonials: "Testimonials",
    contact: "Contact",

    // Hero Section
    heroTitle: "Get the Cheapest Flights Around the World!",
    heroSubtitle: "With NuzhaTrips, travel smart and save more.",
    startSaving: "Start Saving",

    // About Section
    aboutMe: "About Us",
    aboutDescription: "At NuzhaTrips, we specialize in helping travelers and expats secure the cheapest flight deals worldwide 🌍✈️. Our expertise in global routes, paired with smart search tools, allows us to uncover hidden fares and exclusive savings that most people never see. Your next trip starts with smarter travel — and we're here to make it effortless.",
    globalCoverage: "Global Coverage",
    globalCoverageDesc: "Access to flight deals from all major airlines worldwide",
    quickAlerts: "Quick Alerts",
    quickAlertsDesc: "Get notified immediately when prices drop",
    exclusiveDeals: "Exclusive Deals",
    exclusiveDealsDesc: "Special discounts only available to subscribers",
    personalSupport: "Personal Support",
    personalSupportDesc: "Direct WhatsApp support for all your questions",

    // How It Works
    findDeals: "Find Deals",
    findDealsDesc: "I use advanced tools to scan thousands of flight combinations to find the best prices",
    getNotified: "Get Notified",
    getNotifiedDesc: "You'll receive instant alerts when prices drop for your preferred destinations",
    bookSave: "Book & Save",
    bookSaveDesc: "Book directly with the airline using our exclusive deals and save hundreds",
    readyToStart: "Ready to Start Saving?",
    viewPricing: "View Pricing Plans",

    // Pricing
    joinClub: "Join the Club & Save Big",
    startFrom: "Start from just 2.5 OMR/month",
    subscribeNow: "Subscribe Now",
    mostPopular: "MOST POPULAR",
    notReady: "Not Ready to Commit?",
    tryFree: "Try our free newsletter with occasional flight deals",
    subscribe: "Subscribe",

    // Testimonials
    whatMembersSay: "What Our Members Say",

    // Contact
    getInTouch: "Get In Touch",
    contactInfo: "Contact Information",
    email: "Email",
    whatsapp: "WhatsApp",
    location: "Location",
    locationValue: "Muscat, Oman",
    followUs: "Follow Us",
    sendMessage: "Send a Message",
    firstName: "First Name",
    lastName: "Last Name",
    subject: "Subject",
    message: "Message",
    sendMessageBtn: "Send Message",

    // Footer
    footerDescription: "Your personal travel expert helping you find the cheapest flights worldwide.",
    quickLinks: "Quick Links",
    services: "Services",
    flightDeals: "Flight Deals",
    priceAlerts: "Price Alerts",
    travelPlanning: "Travel Planning",
    vipSupport: "VIP Support",
    newsletter: "Newsletter",
    newsletterDesc: "Subscribe to get occasional flight deals",
    copyright: "© 2023 NuzhaTrips.xyz - All rights reserved",

    // Forms
    yourEmail: "Your email address",
    loading: "Loading...",
    success: "Success!",
    error: "Error"
  },
  ar: {
    // Navigation
    home: "الرئيسية",
    about: "معلومات عنا",
    howItWorks: "كيف يعمل",
    pricing: "الأسعار",
    testimonials: "آراء العملاء",
    contact: "اتصل بنا",

    // Hero Section
    heroTitle: "احصل على أرخص تذاكر الطيران حول العالم!",
    heroSubtitle: "مع NuzhaTrips، سافر بذكاء ووفر أكثر",
    startSaving: "ابدأ التوفير",

    // About Section
    aboutMe: "معلومات عنا",
    aboutDescription: "في NuzhaTrips، نتخصص في مساعدة المسافرين والمغتربين للحصول على أرخص عروض الطيران حول العالم 🌍✈️. خبرتنا في الطرق العالمية، إلى جانب أدوات البحث الذكية، تمكننا من الكشف عن أسعار مخفية وتوفيرات حصرية لا يراها معظم الناس. رحلتك القادمة تبدأ بالسفر الذكي — ونحن هنا لنجعلها سهلة وبسيطة.",
    globalCoverage: "تغطية عالمية",
    globalCoverageDesc: "الوصول إلى عروض الطيران من جميع شركات الطيران الكبرى في العالم",
    quickAlerts: "تنبيهات سريعة",
    quickAlertsDesc: "احصل على إشعار فوري عند انخفاض الأسعار",
    exclusiveDeals: "صفقات حصرية",
    exclusiveDealsDesc: "خصومات خاصة متاحة فقط للمشتركين",
    personalSupport: "دعم شخصي",
    personalSupportDesc: "دعم مباشر عبر الواتساب لجميع استفساراتك",

    // How It Works
    findDeals: "البحث عن العروض",
    findDealsDesc: "أستخدم أدوات متقدمة لفحص آلاف خيارات الطيران للعثور على أفضل الأسعار",
    getNotified: "تلقي الإشعارات",
    getNotifiedDesc: "ستتلقى تنبيهات فورية عند انخفاض الأسعار لوجهاتك المفضلة",
    bookSave: "الحجز والتوفير",
    bookSaveDesc: "احجز مباشرة مع شركة الطيران باستخدام عروضنا الحصرية ووفر المئات",
    readyToStart: "هل أنت مستعد للبدء في التوفير؟",
    viewPricing: "عرض خطط الأسعار",

    // Pricing
    joinClub: "انضم إلينا ووفر كثيراً",
    startFrom: "ابدأ من 2.5 ريال فقط شهرياً",
    subscribeNow: "اشترك الآن",
    mostPopular: "الأكثر شعبية",
    notReady: "لست مستعداً للالتزام؟",
    tryFree: "جرب نشرتنا البريدية المجانية مع عروض طيران عرضية",
    subscribe: "اشترك",

    // Testimonials
    whatMembersSay: "ما يقوله أعضاؤنا",

    // Contact
    getInTouch: "تواصل معنا",
    contactInfo: "معلومات الاتصال",
    email: "البريد الإلكتروني",
    whatsapp: "واتساب",
    location: "الموقع",
    locationValue: "مسقط، عمان",
    followUs: "تابعنا",
    sendMessage: "أرسل رسالة",
    firstName: "الاسم الأول",
    lastName: "الاسم الأخير",
    subject: "الموضوع",
    message: "الرسالة",
    sendMessageBtn: "إرسال الرسالة",

    // Footer
    footerDescription: "خبير السفر الشخصي الخاص بك لمساعدتك في العثور على أرخص الرحلات الجوية حول العالم.",
    quickLinks: "روابط سريعة",
    services: "الخدمات",
    flightDeals: "صفقات الطيران",
    priceAlerts: "تنبيهات الأسعار",
    travelPlanning: "تخطيط السفر",
    vipSupport: "دعم مميز",
    newsletter: "النشرة البريدية",
    newsletterDesc: "اشترك للحصول على عروض طيران عرضية",
    copyright: "© ٢٠٢٣ NuzhaTrips.xyz - جميع الحقوق محفوظة",

    // Forms
    yourEmail: "عنوان بريدك الإلكتروني",
    loading: "جاري التحميل...",
    success: "نجح!",
    error: "خطأ"
  }
};

export const useTranslation = (lang) => {
  return (key) => translations[lang][key] || key;
};
